var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PermissionSelector"},[_c('i',{staticClass:"PermissionSelector-Icon",class:_vm.iconClass}),_c('select',{staticClass:"PermissionSelector-Select"},_vm._l((_vm.permissionOptions),function(option){return _c('option',{key:option,domProps:{"value":option,"selected":option === _vm.value}},[_vm._v(_vm._s(option))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }